import { z } from 'zod';

/////////////////////////////////////////
// CASE EXTENSION SCHEMA
/////////////////////////////////////////

export const CaseExtensionSchema = z.object({
  caseExtId: z.number().int(),
  caseId: z.number().int(),
  caseExtensionId: z.number().int(),
  cityId: z.number().int(),
  fieldValue: z.string(),
  rowTimestamp: z.coerce.date(),
})

export type CaseExtension = z.infer<typeof CaseExtensionSchema>

export default CaseExtensionSchema;
